import { computed, reactive } from 'vue'

const searchQueryState = reactive({
  take: 8,
  skip: 0,
  terms: [],
  searchType: null,
  searchTypes: [],
  sorting: null,
  view: null,
  activeCategories: [],
  language: null,

  updated: Date.now(),
  initialized: false
})

export default {
  searchQueryUse(routeData) {
    const state = searchQueryState

    const activeTermsAndFilters = computed(() => {
      const filters = state.activeCategories.map((name) => {
        const type = 'filter'
        return {
          name,
          type
        }
      })
      const terms = state.terms.map((name) => {
        const type = 'term'
        return {
          name,
          type
        }
      })
      return [...filters, ...terms]
    })

    const defaultSorting = computed(() => {
      if (state.searchType === 'product') {
        return 'manual'
      }
      return null
    })

    const resetLastUpdated = () => {
      state.updated = Date.now()
    }

    const setState = (newState) => {
      state.take = newState.itemsCount || 8
      state.skip = newState.skip || 0
      state.activeCategories = newState.activeCategories || []
      state.searchType = newState.searchType
      state.terms = newState.terms || []
      state.sorting = newState.sorting || defaultSorting
      state.view = newState.view
      state.initialized = true
      state.language = newState.language
      resetLastUpdated()
    }

    if (!state.initialized && routeData) {
      setState(routeData)
    }

    const setAllSearchTypes = (searchTypes) => {
      state.searchTypes = searchTypes
    }

    const setSearchType = (searchType) => {
      if (state.searchType === searchType) {
        return
      }

      state.searchType = searchType

      state.skip = 0
      state.sorting = null
      state.view = null
      state.activeCategories = []

      resetLastUpdated()
    }

    const setSorting = (sorting) => {
      if (state.sorting === sorting) {
        return
      }

      state.sorting = sorting
      resetLastUpdated()
    }

    const setView = (view) => {
      if (state.view === view) {
        return
      }

      state.view = view
    }

    const setActiveCategories = (activeCategories) => {
      state.skip = 0
      state.activeCategories = activeCategories || []
      resetLastUpdated()
    }

    const addCategory = (category) => {
      const index = state.activeCategories.indexOf(category)
      if (index === -1) {
        const tempArray = state.activeCategories
        tempArray.push(category)
        setActiveCategories(tempArray)
      }
    }

    const removeCategory = (category) => {
      const index = state.activeCategories.indexOf(category)
      if (index > -1) {
        const tempArray = state.activeCategories
        tempArray.splice(index, 1)
        setActiveCategories(tempArray)
      }
    }

    const removeAllCategories = () => {
      setActiveCategories(null)
    }

    const setTerms = (terms) => {
      state.terms = terms || []
      resetLastUpdated()
    }

    const addTerm = (term) => {
      if (state.terms.indexOf(term) !== -1) {
        return
      }

      state.terms.push(term)
      resetLastUpdated()
    }

    const removeTerm = (term) => {
      const index = state.terms.indexOf(term)
      if (index > -1) {
        const tempArray = state.terms
        tempArray.splice(index, 1)
        setTerms(tempArray)
      }
    }

    const clearTermsAndCategories = () => {
      removeAllCategories(null)
      setTerms()
    }

    const removeTermsAndFilters = (term) => {
      if (term.type === 'filter') {
        removeCategory(term.name)
      }

      if (term.type === 'term') {
        removeTerm(term.name)
      }
    }

    const incrementPage = () => {
      state.skip += state.take
    }

    return {
      searchQuery: state,
      activeCategories: computed(() => state.activeCategories),
      activeTerms: computed(() => state.terms),
      activeTermsAndFilters,
      language: computed(() => state.language),
      searchType: computed(() => state.searchType),
      setState,
      addCategory,
      removeCategory,
      removeAllCategories,
      setTerms,
      addTerm,
      removeTerm,
      clearTermsAndCategories,
      removeTermsAndFilters,
      setActiveCategories,
      setAllSearchTypes,
      setSearchType,
      setSorting,
      setView,
      incrementPage
    }
  }
}
